/* 
Generated code: do not modify this file as it will be overwritten
Template: ImmutableJSRecord.cst

Known Issues/TODO:
- Using *Props type as Record constructor parameter is insufficient.
If a property needs to be a Record type, it should already be constructed.
- Rename Record fromJS factory method to fromJSON
- Create parseJSON method that translates JSON to Props



 */

/* eslint-disable import/order */

import { createSelector } from '@ngrx/store';
import { List, Map, Record, Seq, Set } from 'immutable';
import { AppState } from 'src/store/appstate';
import { getFromOrThrow, propValueOrDefault, tryOrDefault } from 'src/util/values';

export interface WebOrderLogEntityChangesProps {
  id: string;
  entityType: string;
  fieldName: string;
  oldValue: string | null;
  newValue: string | null;
}

export class WebOrderLogEntityChangesRecord extends Record<WebOrderLogEntityChangesProps>({
  id: null as any,
  entityType: null as any,
  fieldName: null as any,
  oldValue: null as any,
  newValue: null as any,
}) {
  public static fromJS(json: {
    id: string;
    entityType: string;
    fieldName: string;
    oldValue: string | null;
    newValue: string | null;
  }): WebOrderLogEntityChangesRecord {
    if (json == null) {
      throw new Error('WebOrderLogEntityChangesRecord.fromJS: parameter cannot be null');
    }
    return new WebOrderLogEntityChangesRecord({
      id: getFromOrThrow(
        json,
        (j) => propValueOrDefault(j, 'id', '00000000-0000-0000-0000-000000000000'),
        'WebOrderLogEntityChangesJson.id',
      ),
      entityType: getFromOrThrow(
        json,
        (j) => j.entityType,
        'WebOrderLogEntityChangesJson.entityType',
      ),
      fieldName: getFromOrThrow(json, (j) => j.fieldName, 'WebOrderLogEntityChangesJson.fieldName'),
      oldValue: json.oldValue,
      newValue: json.newValue,
    });
  }

  public static fromJSUnsafe(json: {
    id: string;
    entityType: string;
    fieldName: string;
    oldValue: string | null;
    newValue: string | null;
  }): [WebOrderLogEntityChangesRecord, Error[]] {
    if (json == null) {
      throw new Error('WebOrderLogEntityChangesRecord.fromJSUnsafe: parameter cannot be null');
    }
    const errors: Error[] = [];

    const record = new WebOrderLogEntityChangesRecord({
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      id: tryOrDefault(
        () =>
          getFromOrThrow(
            json,
            (j) => propValueOrDefault(j, 'id', '00000000-0000-0000-0000-000000000000'),
            'WebOrderLogEntityChangesJson.id',
          ),
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      entityType: tryOrDefault(
        () => getFromOrThrow(json, (j) => j.entityType, 'WebOrderLogEntityChangesJson.entityType'),
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      fieldName: tryOrDefault(
        () => getFromOrThrow(json, (j) => j.fieldName, 'WebOrderLogEntityChangesJson.fieldName'),
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      oldValue: tryOrDefault(
        () => json.oldValue,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      newValue: tryOrDefault(
        () => json.newValue,
        (err) => errors.push(err),
      )!,
    });

    return [record, errors];
  }

  constructor(props: WebOrderLogEntityChangesProps) {
    super(props);
    if (props == null) {
      throw new Error('WebOrderLogEntityChangesRecord constructor parameter cannot be null');
    }
  }
}

export abstract class WebOrderLogEntityChangesViewModelBase
  implements WebOrderLogEntityChangesProps
{
  protected readonly _props: WebOrderLogEntityChangesProps;
  private _json?: WebOrderLogEntityChangesProps;

  get id(): string {
    return this._props.id;
  }
  get entityType(): string {
    return this._props.entityType;
  }
  get fieldName(): string {
    return this._props.fieldName;
  }
  get oldValue(): string | null {
    return this._props.oldValue;
  }
  get newValue(): string | null {
    return this._props.newValue;
  }

  constructor(props: WebOrderLogEntityChangesProps) {
    this._props = props;
  }

  public toJS() {
    return this.toJSON();
  }

  public toJSON() {
    if (this._json == null) {
      this._json = {
        id: this._props.id,
        entityType: this._props.entityType,
        fieldName: this._props.fieldName,
        oldValue: this._props.oldValue,
        newValue: this._props.newValue,
      };
    }
    return this._json;
  }
}
